import { useEffect, useState } from "react";
import Api from "../api/api";
import codeIcon from "../../assets/coupon.png";
import classes from "./CodeList.module.css";
import "../../App.css";
import { Button, Input } from "reactstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import showToast from "../util/toast";

const CodeList = () => {
  const [codes, setCodes] = useState([]);
  const history = useHistory();
  const [reload, setReload] = useState(0);

  useEffect(() => {
    Api.getCodes({ onSuccess: (data) => setCodes(data.data) });
  }, [reload]);

  return (
    <div className="main">
      <div className={classes.topButtonContainer}>
        <Button
          className={"btn-block btn-submit"}
          style={{
            backgroundColor: "#3b5bdb",
            fontSize: 15,
            borderWidth: 0,
            width: 140,
          }}
          onClick={() => history.push("add-code")}
        >
          Add Code
        </Button>
      </div>
      {codes.map((item, index) => (
        <CodeListItem index={index} item={item} setReload={setReload} />
      ))}
    </div>
  );
};

const CodeListItem = ({ item, setReload }) => {
  const history = useHistory();
  const [showDeleteSection, setShowDeleteSection] = useState(false);

  const [deleteConfirmation, setDeleteConfirmation] = useState("");

  const hasUser = !!item.user;
  const name = hasUser ? `${item.user.fname} ${item.user.lname}` : item.name;
  const email = hasUser ? item.user.email : item.email;

  console.log(item);

  const deleteCode = () => {
    if (deleteConfirmation.toUpperCase().trim() == item.code.toUpperCase()) {
      Api.deleteCode({
        params: { code: item.code },
        onSuccess: () => {
          showToast("success", "Successfully deleted");
          setReload((p) => p + 1);
        },
        onError: () => {
          showToast("error", "There was an error");
        },
      });
    } else {
      showToast("error", "Input doesn't match with the code");
    }
  };

  const toggleStatus = () => {
    Api.toggleCodeStatus({
      params: { code: item.code },
      onSuccess: () => {
        showToast("success", "Code updated");
        setReload((p) => p + 1);
      },
      onError: () => showToast("error", "There was an error"),
    });
  };

  return (
    <>
      <div className={classes.itemContainer}>
        <div className={classes.leftContainer}>
          {/* <img src={codeIcon}  width={30} height={30}/> */}
          <div className={classes.codeContainer}>
            <img src={codeIcon} width={28} height={28} />
            <span className={classes.codeText}>{item.code}</span>
          </div>

          <div className={classes.userInfoContainer}>
            <span>{name}</span>
            <span>{email}</span>
          </div>
        </div>
        <div className={classes.rightContainer}>
          <Button
            className={classes.button + " btn-block btn-submit "}
            style={{ backgroundColor: "orange", fontSize: 14, borderWidth: 0 }}
            onClick={() =>
              history.push({
                pathname: "./code-usage",
                state: {
                  code: item.code,
                },
              })
            }
          >
            See Usage
          </Button>
          <Button
            className={classes.button + " btn-block btn-submit "}
            style={{ backgroundColor: "blue", fontSize: 14, borderWidth: 0 }}
            onClick={(event) => {
                history.push({pathname: "./edit-code", params: {data: item}})
            }}
          >
            Edit
          </Button>

          <Button
            className={classes.button + " btn-block btn-submit "}
            style={{ backgroundColor: "gray", fontSize: 14, borderWidth: 0 }}
            onClick={toggleStatus}
          >
            {item.active ? "Disable" : "Enable"}
          </Button>
          <Button
            className={classes.button + " btn-block btn-submit "}
            style={{ backgroundColor: "red", fontSize: 14, borderWidth: 0 }}
            onClick={(event) => {
              setShowDeleteSection(true);
            }}
          >
            Delete
          </Button>
        </div>
      </div>
      {showDeleteSection && (
        <div className={classes.deleteSection}>
          <Input
            placeholder={`Type ${item.code.toUpperCase()} to delete`}
            value={deleteConfirmation}
            onChange={(event) => setDeleteConfirmation(event.target.value)}
          />
          <Button onClick={() => setShowDeleteSection(false)}>Cancel</Button>
          <Button
            style={{ backgroundColor: "red" }}
            onClick={() => deleteCode()}
          >
            Delete
          </Button>
        </div>
      )}
    </>
  );
};

export default CodeList;
